import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { editUserIdApi } from '@/service/modules/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'group-compile',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const form = reactive({
      ding_userid: "",
      name: "",
      id: null
    });
    const subBtnLoading = ref(false);
    const rules = {
      name: [{
        required: true,
        message: "请输入姓名",
        trigger: "blur"
      }],
      ding_userid: [{
        required: true,
        message: "请输入UserId",
        trigger: "blur"
      }]
    };
    const props = __props;
    const formRef = ref();
    const emit = __emit;
    function restForm() {
      form.id = null;
      form.name = "";
      form.ding_userid = "";
      formRef.value?.resetFields();
    }
    function closeDialog() {
      restForm();
      emit("closeDialog");
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      let params = {
        id: form.id,
        name: form.name,
        ding_userid: form.ding_userid
      };
      try {
        let res = await editUserIdApi(params);
        ElMessage.success("操作成功");
        subBtnLoading.value = false;
        closeDialog();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        form.id = props.itemData.id;
        form.name = props.itemData.name;
        form.ding_userid = props.itemData.ding_userid;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "编辑分销用户UserId",
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              disabled: "",
              placeholder: "请输入姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "UserId",
            prop: "ding_userid"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.ding_userid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.ding_userid = $event),
              placeholder: "请输UserId"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});